<template>
  <div class="article">
    <div class="title">洪子晴女爵士 拿督斯里爱心助柬埔寨乡村部落孤儿入读当地大学圆读书梦</div>
    <div class="info">作者：晴天集团    发布于：2025-07-19 18:18</div>
    <p>洪子晴女爵士拿督斯里（Lady Athena Hung Chi Ching,Dato' Sri ）赞助柬埔寨乡村部落孤儿入读当地大学圆读书梦。</p>
    <p>国际知名慈善家、拥有“女爵士”及“拿督斯里”双重荣誉头衔的洪子晴爵士拿督斯里（Lady Athena Hung Chi Ching, Dato' Sri）再度投身公益事业，通过洪子晴慈善基金会，为柬埔寨偏远乡村部落的孤儿们搭建起通往高等教育的桥梁，助力孤儿成功考入当地大学，圆他们的“读书梦”。</p>
    <p>柬埔寨乡村地区教育资源匮乏，尤其对于失去双亲的孤儿而言，别说进入大学，就连完成基础教育都面临重重阻碍。洪子晴爵士,拿督斯里探知柬埔寨暹粒省、马德望省等偏远部落的情况后，深切感受到当地孤儿对知识的渴望与现实条件的落差。“他们眼中的光，让人无法忽视。教育是改变命运的钥匙，无论出身何处，每个孩子都该有机会握住它。” 为此，洪子晴爵士,拿督斯里的洪子晴慈善基金会联合柬埔寨孤兒院的Pastor Nuth先生、柬埔寨当地教育机构及公益组织，启动了“孤儿助学计划”。该计划不仅为符合条件的孤儿提供全额学费资助，还涵盖了书本、住宿、生活补贴等费用，同时对接大学资源，为学生们提供职业规划指导与实习机会，从入学到就业形成“全链条”支持。 首批受助的孤儿中，有不少来自世代以农耕、渔猎为生的部落家庭，他们是家族中第一代走进大学校园的人。19岁的Sokha便是其中之一，她从小在孤儿院长大，如今凭借洪子晴爵士 拿督斯里的洪子晴慈善基金会的支持，考入了柬埔寨皇家农业大学，主修农业技术专业。“我想学好知识，将来回到家乡，教大家科学种植，让部落的生活越来越好。”Sokha的话语中充满了对未来的憧憬。 多年来，洪子晴爵士 拿督斯里始终致力于全球公益事业，尤其关注弱势群体的教育权益。从东南亚到非洲，洪子晴爵士 拿督斯里的慈善足迹遍布多个发展中国家，通过援建学校、设立奖学金、培训教师等方式，让无数困境中的孩子获得了受教育的机会。此次助力柬埔寨孤儿圆大学梦，正是洪子晴爵士“以教育赋能，用爱心筑梦”理念的又一实践。 当地教育部门官员对洪子晴爵士 拿督斯里的善举表示高度赞赏：“这份爱心不仅改变了这些孩子的人生，更为柬埔寨乡村地区的发展注入了希望。当这些年轻人带着知识回到家乡，他们将成为推动社区进步的重要力量。” 目前，“孤儿助学计划”已进入长期运营阶段，覆盖柬埔寨更多偏远地区。洪子晴爵士所说：“公益不是一时的热情，而是长久的坚持。每一个被点亮的梦想，终会汇聚成改变世界的力量。”</p>
    <img src="@/assets/img/article/0719/1.webp" alt="">
    <img src="@/assets/img/article/0719/2.webp" alt="">
    <img src="@/assets/img/article/0719/3.webp" alt="">
    <img src="@/assets/img/article/0719/4.webp" alt="">
    <img src="@/assets/img/article/0719/5.webp" alt="">
    <img src="@/assets/img/article/0719/6.webp" alt="">
    <img src="@/assets/img/article/0719/7.webp" alt="">
    <p>Lady Athena Hung Chi Ching,Dato' Sri Sponsor orphans from rural tribes in Cambodia to attend local universities and realize their dream of studying.</p>
    <p>Internationally renowned philanthropist Lady Athena Hung Chi Ching, Dato' Sri, who holds the dual honorary titles of "Dame" and "Dato' Sri".Once again, she has devoted herself to public welfare. Through the Hung Chi Ching Charitable Foundation, she has built a bridge to higher education for orphans in remote rural tribes of Cambodia, helping them successfully gain admission to local universities and realize their "dream of studying".</p>
    <p>Educational resources are scarce in rural areas of Cambodia, and for orphans who have lost their parents, in particular, there are numerous obstacles even to completing basic education, let alone entering university. After learning about the situation in remote tribes in provinces such as Siem Reap and Battambang in Cambodia, Dame Athena Hung Chi Ching, Dato' Sri, deeply felt the gap between the local orphans' eagerness for knowledge and the harsh reality. "The light in their eyes is impossible to ignore. Education is the key to changing one's fate, and every child, regardless of their background, deserves the opportunity to hold it."To this end,Dame Athena Hung Chi Ching, Dato' Sri's THE HUNG CHI CHING CHARITABLE FUND, in collaboration with Pastor Nuth from a Cambodian orphanage, local educational institutions and public welfare organizations in Cambodia, has launched the "Orphan Education Assistance Program".This program not only provides full tuition funding for eligible orphans, but also covers expenses such as textbooks, accommodation, and living subsidies. Meanwhile, it connects with university resources to offer students career planning guidance and internship opportunities, forming an "all-round chain" of support from enrollment to employment. Among the first batch of aided orphans, many come from tribal families that have made a living by farming and fishing for generations, and they are the first in their families to enter university campuses. Sokha, 19, is one of them. She grew up in an orphanage.Now, with the support of THE HUNG CHI CHING CHARITABLE FUND founded by Dame Athena Hung Chi Ching, Dato' Sri, she has been admitted to the Royal University of Agriculture in Cambodia, majoring in agricultural technology. "I want to acquire knowledge well and return to my hometown in the future to teach everyone scientific planting methods, so that the life of the tribe will get better and better," Sokha said, her words filled with longing for the future. Over the years,Dame Athena Hung Chi Ching, Dato' Sri, has always been committed to global public welfare, with a particular focus on the educational rights and interests of vulnerable groups. From Southeast Asia to Africa, her charitable footprints have spread across many developing countries. Through initiatives such as building schools, establishing scholarships, and training teachers, countless children in difficult circumstances have been given the opportunity to receive education. This effort to help Cambodian orphans realize their university dreams is another practice of Dame Hung's philosophy of "empowering through education and building dreams with love". Local education department officials highly praised Dame Athena Hung Chi Ching, Dato' Sri, for her kindness: "This love not only changes the lives of these children, but also injects hope into the development of rural areas in Cambodia. When these young people return to their hometowns with knowledge, they will become an important force driving community progress." Currently, the "Orphan Education Assistance Program" has entered a long-term operation phase, covering more remote areas in Cambodia. As Dame Athena Hung Chi Ching put it: "Public welfare is not a momentary passion, but a long-term persistence. Every dream that is ignited will eventually converge into a force that changes the world."</p>

  </div>
</template>

<script>
  export default {
    name: '1',
    components: {},
    data() {
      return {}
    }
  }
</script>

<style scoped lang="scss">
  .article{
    width: 70%;
    margin: 20px auto;
    font-family: $font-family;
    .title{
      font-size: 1.4rem;
      font-weight: bold;
      line-height: 50px;
      text-align: center;
    }

    .info{
      height: 28px;
      line-height: 28px;
      border-bottom: 1px #e8e8e8 solid;
      margin: 0;
      text-align: center;
      font-size: 0.8rem;
    }

    p{
      font-size: $content-font-size;
      color: #000000;
      line-height: 2;
      margin: 20px 0;
    }

    img{
      width: 60%;
      margin-left: 20%;
    }

    .img-alt{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      padding-top: 10px;
      color: #2f2e2e;
      font-size: 0.9rem;
    }

    .img-alt-content{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      padding-top: 5px;
      padding-bottom: 15px;
      color: #2f2e2e;
      font-size: 0.9rem;
    }
  }

  @media (max-width: 768px) {
    .article{
      width: 90%;
      margin: 20px auto;
      .title{
        padding-top: 10px;
        padding-bottom: 8px;
        font-size: 1.1rem;
        font-weight: bold;
        line-height: 1.3;
        text-align: center;
      }

      .info{
        height: 28px;
        line-height: 28px;
        border-bottom: 1px #e8e8e8 solid;
        margin: 0;
        text-align: center;
        font-size: 0.8rem;
      }

      p{
        font-size: $phone-content-font-size;
        color: #000000;
        line-height: 2;
        margin: 20px 0;
      }

      img{
        width: 80%;
        margin-left: 10%;
      }

      .img-alt{
        text-align: center;
        line-height: 1;
        margin: 6px 0;
        color: #2f2e2e;
        padding-top: 5px;
        font-size: 0.8rem;
      }
      .img-alt-content{
        text-align: center;
        line-height: 1;
        margin: 6px 0;
        padding-top: 5px;
        padding-bottom: 15px;
        color: #2f2e2e;
        font-size: 0.8rem;
      }
    }
  }

  @media (max-width: 480px) {
    .article{
      width: 100vw;
      padding: 0 10px;
      box-sizing: border-box;
      margin: 20px auto;
      .title{
        padding-top: 10px;
        padding-bottom: 8px;
        font-size: 1.1rem;
        font-weight: bold;
        line-height: 1.3;
        text-align: center;
      }

      .info{
        height: 28px;
        line-height: 28px;
        border-bottom: 1px #e8e8e8 solid;
        margin: 0;
        text-align: center;
        font-size: 0.8rem;
      }

      p{
        font-size: $phone-content-font-size;
        color: #000000;
        line-height: 2;
        margin: 20px 0;
      }

      img{
        width: 100%;
        margin: 0;
      }

      .img-alt{
        text-align: center;
        line-height: 1;
        font-size: 0.7rem;
        margin: 6px 0;
        color: #666;
      }
    }
  }
</style>
